import React, { Component } from 'react';
import styled from 'styled-components';
import { InsuranceTransitionGroup } from './StyledSectionComponents';
import PhotoCapture from '../../../../PhotoCapture/PhotoCapture';
import { ScanCardPlanConnector } from './ScanCardPlanConnector';
import { ScanCardCarrierConnector } from './ScanCardCarrierConnector';
import { ScanCardResultsConnector } from './ScanCardResultsConnector';
import { Button } from '../../../../button';
import { FormattedMessage } from 'react-intl';
import { MetricsClickable } from '@zocdoc/frontend-metrics';

const TopSectionPadding = styled.div`
    padding: 20px 0;
`;

const RelativeParent = styled.div`
    position: relative;
`;

const ButtonWrapper = styled.div`
    width: 100%;
    position: fixed;
    bottom: 0px;
    padding: 24px 44px;
`;

const FullWidthButton = styled(Button)`
    width: 100%;
`;

export default class ScanCardInsurancePickerV2View extends Component {
    photoCaptureRef = React.createRef();

    componentDidMount() {
        this.photoCaptureRef.current.setImageData(this.props.imageFront, true);
    }

    render() {
        return (
            <div>
                <TopSectionPadding />
                <PhotoCapture
                    ref={this.photoCaptureRef}
                    onChangeCallback={this.handlePhotoCaptureChange}
                    text="Place your card on a flat surface, and tap to capture the front."
                />
                <RelativeParent>
                    <InsuranceTransitionGroup
                        transitionEnterTimeout={0}
                        transitionLeaveTimeout={0}
                        transitionName="left"
                    >
                        {this.renderResults()}
                    </InsuranceTransitionGroup>

                    <InsuranceTransitionGroup
                        transitionEnterTimeout={0}
                        transitionLeaveTimeout={0}
                        transitionName="right"
                    >
                        {this.renderSubList()}
                    </InsuranceTransitionGroup>
                </RelativeParent>
                {this.renderButton()}
            </div>
        );
    }

    renderButton() {
        const { showResults, clickContinue } = this.props;

        if (showResults) {
            return (
                <MetricsClickable
                    action="Insurance Picker Scan - Clicked Continue"
                    element="Continue"
                >
                    <ButtonWrapper>
                        <FullWidthButton
                            data-test="continue-button"
                            data-uem-id="continue-button"
                            onClick={clickContinue}
                        >
                            <FormattedMessage
                                defaultMessage="Continue"
                                id="InsurancePicker.ScanCard.Continue"
                            />
                        </FullWidthButton>
                    </ButtonWrapper>
                </MetricsClickable>
            );
        }
    }

    renderResults() {
        if (this.props.showResults) {
            return <ScanCardResultsConnector key="results-view" />;
        }
    }

    renderSubList() {
        if (this.props.showCarriers) {
            return <ScanCardCarrierConnector key="carrier-view" />;
        } else if (this.props.showPlans) {
            return <ScanCardPlanConnector key="plan-view" />;
        }
    }

    handlePhotoCaptureChange = () => this.chooseScanCardPhoto();

    chooseScanCardPhoto() {
        const img = this.photoCaptureRef.current.getImageData(true);
        this.props.fetchScanCard(img);
    }
}
